import React from 'react';

import FieldGroup from '../FieldGroup';

export default function renderFieldGroup({
  fieldGroup,
  form,
  isVisible,
  tabindex,
  gridStyle,
  readOnly,
  headerRight,
  groupSizeOffset,
  title,
  isSubmitting,
  disabled,
  submitButtonLabel,
  titleStyle,
  inlineSubmitButton,
  index,
  innerIndex,
  arrayFieldName,
  isArray,
  onDragStart,
  inlineRight,
  inlineLeft,
  isSettingsForm,
  noTitle,
}) {
  return (
    <FieldGroup
      isSettingsForm={isSettingsForm}
      headerRight={index === 0 ? headerRight : null}
      isTitleHidden={fieldGroup.isTitleHidden || noTitle}
      prevGroupsSize={
        form.fields.slice(0, index).reduce((acc, curr) => {
          return acc + curr.fields.length;
        }, 0) + groupSizeOffset
      }
      key={fieldGroup.title}
      title={title || fieldGroup.title}
      subTitle={fieldGroup.subTitle}
      fields={fieldGroup.fields}
      formik={form.formik}
      isVisible={isVisible}
      tabindex={tabindex}
      gridStyle={gridStyle}
      readOnly={readOnly}
      titleStyle={titleStyle}
      isSubmitting={isSubmitting}
      disabled={disabled}
      submitButtonLabel={submitButtonLabel}
      inlineSubmitButton={inlineSubmitButton}
      isLastOne={index === form.fields.length - 1}
      isArray={isArray}
      innerIndex={innerIndex}
      arrayFieldName={arrayFieldName}
      isDraggable={fieldGroup.isDraggable}
      onDragStart={onDragStart}
      inlineRight={inlineRight}
      inlineLeft={inlineLeft}
      noTitle={noTitle}
    />
  );
}
